import { getProductUrl } from '../../assets/js/common'
import store from '../../store'
import Vue from 'vue'
const eCommerceEvents = {
  state: {
    currency: 'INR',
    tatvicProductImpression: {
      data: []
    }
  },
  getters: {
    currency: (state) => state.currency,
    getUserTatvicCartItems () {
      let giftVoucherData = store.getters._cart && store.getters._cart.giftvouchers && store.getters._cart.giftvouchers.items && store.getters._cart.giftvouchers.items.length && store.getters._cart.giftvouchers.items.map((itm, index) => {
        return {
          producturl: 'https://www.thesouledstore.com/gift-voucher',
          membership_price: 0,
          item_name: 'Gift Voucher',
          item_id: (itm?.gv_id && itm.gv_id.toString()) || '0',
          price: itm?.gvamount || 0,
          item_category: itm?.category || '',
          index: index,
          quantity: itm?.quantity || 1,
          discount: 0,
          currency: 'INR',
          item_brand: 'The Souled Store'
        }
      })
      let tatvicData = store.getters._cart && store.getters._cart.products && store.getters._cart.products.items && store.getters._cart.products.items.length && store.getters._cart.products.items.map((itm, index) => {
        let productUrl = getProductUrl(true, itm.url_key, itm.gender_type)
        let productImage = (itm && Array.isArray(itm.images) && itm.images[0]) ? process.env.IMG_BASE_URL + process.env.PRODUCT_DETAIL_IMG + itm.images[0] : 'NA'
        let size = (itm && itm.size) ? itm.size : 'NA'
        let variantId = (itm && itm.size && Array.isArray(itm.variant)) ? ((itm.variant.find(v => v.size === itm.size) || {}).id || 'NA') : 'NA'
        return {
          producturl: productUrl,
          image: productImage,
          size: size,
          variant_id: variantId,
          membership_price: itm && itm.exclusive_price ? Number(itm.exclusive_price) : 0,
          artist_name: itm && itm.artist ? itm.artist.replace('\u0099', '') : 'NA',
          item_name: itm.product,
          item_id: String(itm.parent_prod_id) || String(itm.prod_id),
          price: itm && itm.price ? Number(itm.price) : 0,
          item_category: itm.category,
          index: index + 1,
          quantity: itm.quantity,
          discount: itm && itm.spl_price ? Number(itm.spl_price) : 0,
          currency: 'INR',
          item_brand: 'The Souled Store',
          // coupon: itm.coupon_discount || 'NA',
          item_category2: itm.size || 'NA'
        }
      })
      return [...(giftVoucherData || []), ...(tatvicData || [])]
    },
    getUserTatvicBuyNowItem () {
      let buynowTatvicData = store.getters._buyNowCart && store.getters._buyNowCart.products && store.getters._buyNowCart.products.items && store.getters._buyNowCart.products.items.length && store.getters._buyNowCart.products.items.map((itm, index) => {
        return {
          item_name: itm.product,
          item_id: itm.prod_id,
          price: store.getters.isExclusive && itm.exclusive_price ? itm.exclusive_price : ((itm.splPrice || itm.spl_price) && (itm.splPrice > 0 || itm.spl_price > 0)) ? itm.splPrice || itm.spl_price : itm.price,
          item_category: itm.category,
          index: index + 1,
          quantity: itm.quantity,
          discount: itm.price - (store.getters.isExclusive && itm.exclusive_price ? itm.exclusive_price : ((itm.splPrice || itm.spl_price) && (itm.splPrice > 0 || itm.spl_price > 0)) ? itm.splPrice || itm.spl_price : itm.price),
          currency: 'INR',
          item_brand: 'The Souled Store',
          coupon: itm.coupon_discount || 'NA',
          item_category2: itm.size || 'NA'
        }
      })
      return buynowTatvicData
    },
    tatvicProductImpression: state => state.tatvicProductImpression
  },
  actions: {
    ECOMMERCE_EVENT: (state, {eventName, payload}) => {
      const routeObj = Vue.ls.get('routeObj')
      const ecommDefaultPayload = {
        USER_ID: store.getters.get_user_id ? store.getters.get_user_id : 'NA',
        USER_TYPE: store.getters.get_exclusive_user ? store.getters.get_exclusive_user : 'NA',
        SOURCE: routeObj.previous ? routeObj.previous : 'NA',
        PAGE_NAME: routeObj.current ? routeObj.current : 'NA',
        LOGGED_IN_STATUS: store.getters.authStatus ? 'Logged In' : 'Non Logged In'
      }
      state.commit('GTAG_EVENT', {eventName, payload: {...ecommDefaultPayload, ...payload}})
    }
  },
  mutations: {
    EC_PLP_PROD_VIEW_RESET: (state, payload) => {
      state.tatvicProductImpression.data = []
    },
    EC_PLP_PROD_VIEW_PUSH: (state, payload) => {
      state.tatvicProductImpression.data.push(payload)
    }
  }
}
export default eCommerceEvents



// WEBPACK FOOTER //
// ./src/store/modules/e-commerceEvents.js